export enum ENUM__field_connectable_type {
  ANY = 'any',
  ANY__LIST = 'any list',
  ANY__ML_ASSET = 'any ml asset',
  //
  INT = 'int',
  FLOAT = 'float',
  BOOL = 'bool',
  SEED = 'seed',

  TOKEN = 'token',
  //
  STRING = 'string',
  STRING_ENUM = 'enum',
  STRING_UUID = 'uuid',
  STRING_HASH_IMAGE_GENERATED = 'hash image generated',
  STRING_HASH_ML_ASSET = 'hash ml asset',
  //
  TENSOR_LATENTS_MASKED = 'tensor latents masked',
  TENSOR_LATENTS = 'tensor latents',
  TENSOR_IMAGE = 'tensor image',
  TENSOR_IMAGE_MASK_BOOLEAN = 'tensor image mask boolean',

  //
  CONDITIONING_SD = 'conditioning sd',
  CONDITIONING_SD_MASKED = 'conditioning sd masked',

  IMAGE_ASSET = 'image asset',
  IMAGE_CROP_BOX = 'image crop box',
  IMAGE_SEGMENTS = 'image segments',

  IMAGE = 'image',
  IMAGE_SIZE = 'image size',

  ML_ASSET__VAE = 'ml asset. vae',
  ML_ASSET__UNET = 'ml asset. unet',
  ML_ASSET__UNET_FREE_U = 'ml asset. unet free u',
  ML_ASSET__CLIP = 'ml asset. clip',

  ML_ASSET__CONTROL_NET = 'ml asset. control net',
  ML_ASSET__LORA = 'ml asset. lora',
  ML_ASSET__IP_ADAPTER = 'ml asset. ip adapter',
  ML_ASSET__T2I_ADAPTER = 'ml asset. t2i adapter',

  LIST = 'list',

  LIST_FLOAT_DYNAMIC = 'list float dynamic',

  GRID2D_MODE = 'grid2d mode',
}
